import { Box, Stack, Typography, tokens } from '@cast/design-system';

type StepBadgeProps = {
  number: number;
  hasConnector?: boolean;
};

export const StepBadge = ({ number, hasConnector }: StepBadgeProps) => (
  <Stack alignItems="center" alignSelf="stretch" sx={{ width: 28 }}>
    <Box
      sx={{
        width: 28,
        height: 28,
        borderRadius: '14px',
        backgroundColor: tokens.theme.bg.selection.primary,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}
    >
      <Typography
        variant="P14B"
        sx={{ color: tokens.theme.fg.structural.primaryOnInverse }}
      >
        {number}
      </Typography>
    </Box>
    {hasConnector ? (
      <Box
        aria-hidden
        sx={{
          flex: 1,
          width: '1px',
          minHeight: 16,
          bgcolor: tokens.theme.border.structural.neutral,
        }}
      />
    ) : null}
  </Stack>
);
